
<div class="flex bg-gray-50 px-20 py-24" gloZoomOnScroll>
    <div class="flex flex-col pt-[96px] pb-[166px] px-8">
        <div class="">
            <h1 class="text-5xl pb-6 text-gray-900">Book Your Salon Visit in Seconds</h1>
            <p class="text-lg pb-12 text-gray-600">Find top-rated salons, compare services, and secure your appointment—effortlessly.</p>
            <div class="flex">
                <button class="px-6 py-2 shadow rounded-3xl bg-white mr-3">Learn More</button>
                <button class="px-6 py-2 shadow rounded-3xl bg-gray-950 text-white">Get Started</button>
            </div>

        </div>
    </div>
    <div class="pr-8 overflow-hidden">
        <img [src]="assetUrl + 'img/whyus3.png'" alt="Why Us">
    </div>
</div>